import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Pagination, Navigation } from "swiper/modules";

import { Card, CardContent, Typography, Button, Modal } from "@mui/material";
const testimonialsData = [
  {
    name: "Vijay R",
    content: `It was a great experience completing my training with Suneesh. He is a resourceful person with great experience. He helped me not only in developing technical skills but also to align into the culture of the IT industry.`,
  },
  {
    name: "Binoy Barnabas",
    content: ` I have no words to say. Suneesh is a java geek and his team is
    again a bunch of other techies like him. It's not only just the
    tech, but we will also enjoy the whole process of learning and
    development. Ask him any doubt, he will try his best to resolve
    the issue and his team is super supportive. Nothing more to say.
    One more thing to add. He not only covers programming, but also
    you will get exposure to software development processes as well.`,
  },
  {
    name: "Libin Prince",
    content: ` I confidently endorse Suneesh Thampi as an outstanding educator
    and life advisor; within just one month, I have experienced
    substantial personal and academic growth under their insightful
    guidance and support.`,
  },
  {
    name: "Soorajkhan",
    content: ` I am Soorajkhan and what I believe is, your teaching way and interaction with students are just remarkable. when you are coming to take the classes I just feel like gaining positive energy. because you are giving that kind of atmosphere in the class. I'm so happy to have you as my mentor.`,
  },
  {
    name: "Gokul Surendran",
    content: ` Being part of the training session with Suneesh and the team
    proved to be a highly valuable experience. The focus on managing
    work-related stress was a significant highlight. The session, as
    a whole, was engaging, and the team showcased remarkable
    technical expertise. Their approachable nature facilitated an
    effortless resolution of doubts, contributing to a seamless
    learning journey.`,
  },
];

export default function Testimonial() {
  const [showAllContent, setShowAllContent] = useState(false);
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);

  const handleViewMore = (testimonial) => {
    setSelectedTestimonial(testimonial);
    setShowAllContent(true);
  };

  const handleCloseModal = () => {
    setShowAllContent(false);
    setSelectedTestimonial(null);
  };
  return (
    <div>
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        loop={true}
        pagination={{
          clickable: true,
        }}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        modules={[Pagination, Navigation]}
        className="mySwiper"
      >
        <div className="swiper-button-prev" style={{ color: "#ffe000" }}></div>
        <div className="swiper-button-next" style={{ color: "#ffe000" }}></div>
        {testimonialsData.map((testimonial, index) => (
          <SwiperSlide key={index}>
            <Card
              sx={{
                borderRadius: "0px",
                minWidth: 275,
                minHeight: 270,
                padding: "10px 30px 0px 30px",
                background: "#1b1b1b",
              }}
            >
              <CardContent>
                <Typography
                  fontFamily="inter"
                  color="#ffe000"
                  fontWeight="600"
                  sx={{ fontSize: { xs: "19px", sm: "24px" } }}
                >
                  {testimonial.name}
                </Typography>
                {window.innerWidth > 600 ? (
                  <Typography
                    sx={{ fontSize: { xs: "16px", sm: "20px" } }}
                    fontFamily="inter"
                    color="white"
                    fontWeight="400"
                  >
                    {testimonial.content}
                  </Typography>
                ) : (
                  <div>
                    <Typography
                      sx={{ fontSize: { xs: "16px", sm: "20px" } }}
                      fontFamily="inter"
                      color="white"
                      fontWeight="400"
                    >
                      {testimonial.content.substring(0, 100)}...
                    </Typography>
                    <Typography
                      onClick={() => handleViewMore(testimonial)}
                      color="#ffe000"
                    >
                      Read More
                    </Typography>
                  </div>
                )}
              </CardContent>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
      <Modal
        open={showAllContent}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            backgroundColor: "#1b1b1b",
            border: "2px solid #000",
            boxShadow: 24,
            padding: "30px",
            height: "50vh",
            overflowY: "scroll",
          }}
        >
          {selectedTestimonial && (
            <div>
              <Typography
                fontFamily="inter"
                color="#ffe000"
                fontWeight="600"
                sx={{ fontSize: { xs: "19px", sm: "24px" } }}
              >
                {selectedTestimonial.name}
              </Typography>
              <Typography
                sx={{ fontSize: { xs: "16px", sm: "20px" } }}
                fontFamily="inter"
                color="white"
                fontWeight="400"
              >
                {selectedTestimonial.content}
              </Typography>
            </div>
          )}
          <Button
            onClick={handleCloseModal}
            style={{ background: "#ffe000", color: "black", marginTop: "10px" }}
            variant="contained"
          >
            Close
          </Button>
        </div>
      </Modal>
    </div>
  );
}
